// Copyright: IQGeo Limited 2010-2019
import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import myw from 'myWorld-base';
import userGroupsHtml from 'text!html/userGroups.html';
import Dialog from 'myWorld/uiComponents/dialog';
import 'myWorld/controls/userGroups/userGroupDetails';
import 'myWorld/controls//userGroups/userGroupEditor';
import 'myWorld/controls/userGroups/createUserGroupDialog';
import 'jquery-contextMenu';

myw.UserGroupsManager = Dialog.extend({
    id: 'user-groups-manager',
    className: 'list',

    options: {
        modal: true,
        autoOpen: true,
        destroyOnClose: true,
        minWidth: 400,
        width: 400,
        resizable: true,
        position: { my: 'center', at: 'top', of: window },
        title: '{:manage_title}',
        buttons: {
            Close: {
                text: '{:close_btn}',
                class: 'right',
                click() {
                    this.close();
                }
            }
        }
    },
    /**
     * @class Creates a list of all the groups the user has access to and puts it in a dialog
     * @param  {System}  system
     * @constructs
     */
    initialize(options) {
        this.owner = options.owner;
        this.system = options.system;

        myw.Dialog.prototype.initialize.call(this, options);
    },

    setHeight() {
        this.$el.css({
            'max-height': $(window).height() - 110,
            'overflow-y': 'auto',
            'overflow-x': 'hidden'
        });
    },

    async render() {
        const hasPerm = await this.system.userHasPermission('editGroups');
        if (hasPerm) {
            this.options.buttons['Add'] = {
                text: '{:add_new}',
                class: 'primary-btn',
                click: () => {
                    this.showCreateDialog();
                }
            };
        }
        await this.populateGroupsList();
        myw.Dialog.prototype.render.call(this);

        // Resize the groups list on window resize
        $(window)
            .resize(() => {
                this.setHeight();
            })
            .resize();
    },

    /*
     * Populates the list of groups (with its members) accessible to the user
     */
    async populateGroupsList() {
        this.$el.empty();
        const groups = await this.getGroupsDetails();
        if (groups.length === 0) {
            this.populateWithEmptyMsg();
        } else {
            const refactoredGroups = this._processGroups(groups);
            //Sort the groups list alphabetically
            const sortedGroups = _.sortBy(refactoredGroups, group => group.name.toLowerCase());

            _.each(sortedGroups, group => this.addItemToList(group));
        }
        this.delegateEvents();
        return;
    },

    /**
     * Gets the details for each group from the database
     * @return {array<Promise>}
     */
    async getGroupsDetails() {
        const groupIds = await this.system.getGroupsIds();
        const groups = [];
        _.each(groupIds, groupId => {
            groups.push(this.system.getGroup(groupId));
        });
        return Promise.all(groups);
    },

    /**
     * For groups with conflicting group names, adds the owner in brackets with the group name
     * @param {array<object>}  groups
     * @return {array<object>}
     */
    _processGroups(groups) {
        const refactoredGroups = [];
        let displayName;

        //Add the owner in brackets to the group names that are ambiguous
        _.each(groups, group => {
            if (_.where(groups, { name: group.name }).length > 1) {
                displayName = `${group.name} (${group.owner})`;
            } else {
                displayName = group.name;
            }

            refactoredGroups.push(_.extend(_.clone(group), { display_name: displayName }));
        });

        return refactoredGroups;
    },

    /*
     * Adds a message to the dialog indicating that there are no accessible groups
     */
    populateWithEmptyMsg() {
        this.$el.html($('<div>', { text: this.msg('no_saved'), class: 'group-manager-msg' }));
    },

    /**
     * Creates a groupRow and adds it to the list
     */
    addItemToList(item) {
        const groupRow = new GroupRow({ owner: this, groupObj: item });
        this.$el.append(groupRow.render());
    },

    /**
     * Shows the create group dialog
     */
    showCreateDialog() {
        new myw.CreateUserGroupDialog({ owner: this });
    }
});

const groupRowHtml = $(userGroupsHtml)
    .filter('#group-manager-row-template')
    .html();
const GroupRow = Backbone.View.extend({
    className: 'group-manager-row',
    messageGroup: 'UserGroupsManager',
    events: {
        click: 'openGroupEditor'
    },
    template: _.template(groupRowHtml),
    initialize(options) {
        this.owner = options.owner;
        this.group = options.groupObj;
    },

    render() {
        let membersList = '';
        _.each(_.keys(this.group.members), member => {
            if (membersList.length === 0) membersList = member;
            else membersList = `${membersList}, ${member}`;
        });
        this.groupId = `${this.group.owner}:${this.group.name}`;
        this.$el.html(
            this.template({
                groupId: this.groupId,
                name: this.group.display_name,
                members: membersList
            })
        );
        return this.$el;
    },

    openGroupEditor() {
        //Check if the user should see an editor or just group details
        this.owner.system.userHasPermission('editGroups').then(hasPerm => {
            const canEdit =
                this.group.members[myw.currentUser.username] === true ||
                this.group.owner === myw.currentUser.username;
            if (hasPerm && canEdit) {
                new myw.UserGroupEditor({
                    owner: this.owner,
                    system: this.owner.system,
                    groupId: this.groupId
                });
            } else {
                const groupDetails = new myw.UserGroupDetails({
                    owner: this.owner,
                    groupId: this.groupId
                });
                groupDetails.show();
            }
        });
    }
});

export default myw.UserGroupsManager;
